import React, { FC } from "react";
import { Link } from "react-router-dom";

import {
  careerAnswerHistoryPath,
  careerReferencePath,
} from "../../store/student";
import MapActionButtons from "../../organisms/Career/MapActionButtons";
import { ReactComponent as Logo } from "../../assets/images/Career/logo.svg";

import styles from "./Career.module.scss";

type Props = {
  createCareerSheets: () => void;
  onOpenChallengeSheet: () => void;
};

const Career: FC<Props> = ({ createCareerSheets, onOpenChallengeSheet }) => {
  return (
    <div className={styles.wrapper}>
      <Link to={careerReferencePath} className={styles.referenceLink}>
        キャリア開拓モードとは？
      </Link>
      <div className={styles.hero}>
        <Logo className={styles.logo} />
        <div className={styles.title}>
          <p className={styles.main}>
            GEARキャリア
            <br className={styles.isSp} />
            開拓モードにようこそ！
          </p>
          <p className={styles.sub}>
            あなたの回答をもとに、
            <br className={styles.isSp} />
            AIがキャリアづくりをサポートします。
          </p>
        </div>
      </div>
      <div className={styles.actionButtons}>
        <MapActionButtons
          createCareerSheets={createCareerSheets}
          onOpenChallengeSheet={onOpenChallengeSheet}
        />
      </div>
      <Link to={careerAnswerHistoryPath} className={styles.answerHistoryLink}>
        今までの回答をみる
      </Link>
    </div>
  );
};

export default Career;
